import React from "react";
import { Editor } from "slate";
import { Plugin } from "slate-react";
import { MARKS } from "../html";
import { AddHotkey } from "./hotkey";
import { AddIsToggledQuery } from "./isToggled";
import { AddToggleCommand } from "./toggleCommand";

const { type } = MARKS.BOLD;

const isBold = (editor: Editor) => editor.value.marks.some(x => x.type === type);

const toggleBold = (editor: Editor) => editor.toggleMark(type);

/**
 * Slate plugin for bold formatting
 */
export const Bold: Plugin[] = [
  AddIsToggledQuery(type, isBold),
  AddToggleCommand(type, toggleBold),
  AddHotkey({ key: "b", action: toggleBold }),
  {
    renderMark: (props, controller, next) => {
      const { mark, attributes } = props;
      if (mark.type === type) {
        return <strong {...attributes}>{props.children}</strong>;
      }
      else {
        return next();
      }
    },
  },
];
